


import {
    Card,
    Divider,
    Grid,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Container,
    Drawer,
    Box
} from '@mui/material'
import moment from 'moment'

function BuyNewOrderDrawer({
    title,
    onChangeUserCount,
    entitlementData,
    visible,
    onClose,
    currentPlan,
    calculationData,
    noOfUsers,
    onSubmit,

}) {
    if (calculationData == undefined) {
        calculationData = {
            subtotal: 0,
            total: 0,
            net_amount: 0,
        }
    }


    const calculateBuyNewUserOrder = (e) => {
        onChangeUserCount(e.target.value)
    }

    return (
        <div>
            {/* Buy New User Drawer */}
            <Drawer
                anchor="right"
                backdrop="static"
                variant="temporary"
                open={visible}
                onClose={onClose}
                PaperProps={{
                    sx: {
                        width: {
                            lg: 400,
                            md: 300,
                        }
                    }
                }}
            >
                <Container sx={{ padding: 5 }}>
                    <Box sx={{ textAlign: "center" }} >
                        <Typography
                            style={{ fontSize: 14, fontWeight: 'bold', marginTop: 5 }}
                            gutterBottom
                        >
                            {title}
                        </Typography>
                        <Divider spacing={10} />

                    </Box>
                    <Grid container spacing={2} sx={{ paddingTop: 5 }}>
                        <Grid item md={6}>
                            <TextField
                                size='small'
                                name="users"
                                label="No of Users"
                                value={noOfUsers}
                                variant="outlined"
                                fullWidth
                                margin="dense"
                                onChange={(e) => calculateBuyNewUserOrder(e)}
                                my={2}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <Typography style={{ fontSize: 14, paddingTop: 15 }} gutterBottom>
                                Purchase Type : New
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} style={{ marginTop: 1, paddingLeft: 2, paddingRight: 2 }}>
                        <Grid item md={6}>
                            <Typography variant='subtitle2'>
                                Plan Expiry
                            </Typography>
                            <Typography
                                style={{
                                    marginTop: 8,
                                    fontSize: 14,
                                    fontWeight: 'bold',
                                }}
                            >
                                {moment(new Date(entitlementData?.expiry_date)).format("DD-MM-YYYY")}
                            </Typography>
                        </Grid>
                        <Grid item md={6}>
                            <Typography variant='subtitle2'>
                                Allowed Users in Plan
                            </Typography>
                            <Typography
                                style={{
                                    marginTop: 8,
                                    fontSize: 14,
                                    fontWeight: 'bold',
                                }}
                            >
                                {currentPlan?.max_users}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Card style={{ marginTop: 15 }}>
                        <Table size="small" >
                            <TableHead>
                                <TableRow>
                                    <TableCell>Plan Name</TableCell>
                                    <TableCell align="left"> Qty</TableCell>
                                    <TableCell align="left"> Unit Price</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {entitlementData?.current_plan?.name}
                                    </TableCell>
                                    <TableCell align="left"> {noOfUsers || 0}</TableCell>
                                    <TableCell align="left">Rs {currentPlan?.price_per_user}</TableCell>
                                </TableRow>
                            </TableBody>
                            <TableBody>
                                <TableRow>
                                    <TableCell rowSpan={8} />
                                    <TableCell colSpan={1} style={{ fontWeight: 'bold' }}>
                                        Subtotal
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {calculationData.subtotal}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={1} style={{ fontWeight: 'bold' }}>
                                        GST
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {' '}
                                        {currentPlan?.igst} %
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={1} style={{ fontWeight: 'bold' }}>
                                        Total
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {' '}
                                        {calculationData.total}{' '}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={1} style={{ fontWeight: 'bold' }}>
                                        Credit Amount
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {' '}
                                        {entitlementData.credit_note}{' '}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={1} style={{ fontWeight: 'bold' }}>
                                        Net Amount
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                                        {' '}
                                        {calculationData.net_amount}{' '}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Card>
                    <Grid container spacing={6}>
                        <Grid item md={12} />
                    </Grid>
                    {/* <DisplayPaymentOptions/> */}
                    <Grid container spacing={6} style={{ paddingTop: 20 }}>
                        <Grid item md={12}>
                            <Button
                                onClick={onSubmit}
                                style={{ width: '28%' }}
                                variant="contained"
                                size="small"
                                color="primary"
                                mt={3}
                            >
                                Pay {calculationData.net_amount}
                            </Button>
                        </Grid>
                    </Grid>
                </Container>
            </Drawer>
        </div>
    )
}

export default BuyNewOrderDrawer;